module.exports = __webpack_public_path__ + "img/2.c6c8edf0.svg";